import { useId } from "react";
import { Blend } from "lucide-react";
import { useTranslation } from "react-i18next";
import { dispatchMetadataEvent } from "../../lib/metadata-history/dispatch";
import { useMetadataEditingStore } from "../../stores/metadata-editing-store";
import { useCanvasMetadataTargets } from "../../lib/schedule-art/canvas-state";
import { PlacementNumberField } from "../editor-panel/developer-section/PlacementNumberField";

export function MetadataPositionFields() {
  const { t } = useTranslation();
  const id = useId();
  const targets = useCanvasMetadataTargets();
  const graphicsOpacity = useMetadataEditingStore(state => state.graphicsOpacity);
  const setView = useMetadataEditingStore(state => state.setView);
  const selectedPath = useMetadataEditingStore(state => state.selected);
  const liveX = useMetadataEditingStore(state => state.livePoint?.[0]);
  const liveY = useMetadataEditingStore(state => state.livePoint?.[1]);
  const selected = targets.find(target => target.path === selectedPath);
  const isAbsolute = selected?.path.startsWith("globals.") || selected?.path.endsWith(".origin");
  const help = isAbsolute ? t("metadata.canvas.absolute") : t("metadata.canvas.offset");
  const live = [liveX, liveY];

  return (
    <div className="flex min-w-60 flex-1 overflow-hidden rounded-lg border border-neutral-200 bg-white">
      {[0, 1].map(axis => (
        <PlacementNumberField key={`${selectedPath}:${axis}`} id={`${id}-${axis}`}
          label={axis === 0 ? "X" : "Y"} title={selected ? help : undefined}
          value={live[axis] ?? selected?.point[axis] ?? 0} disabled={!selected}
          onChange={value => {
            if (!selected) return;
            const point = selected.point.map((coordinate, index) => index === axis ? value : coordinate);
            dispatchMetadataEvent({ type: "position/set", path: selected.path, point }, `${selected.path}:${axis}`);
          }} />
      ))}
      <PlacementNumberField id={`${id}-opacity`} opacity value={graphicsOpacity}
        label={<Blend className="size-3.5" />} title={t("metadata.canvas.opacity")}
        onChange={graphicsOpacity => setView({ graphicsOpacity })} />
    </div>
  );
}
